import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import bg from "../../assets/images/bg-login.jpg";
import { useNavigate } from 'react-router-dom';
import { publicIpv4 } from "public-ip";
import "./resetpassword.css"
function Verify() {
    const [status, setStatus] = useState(null);
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");
    const hash = searchParams.get("hash");
    const expires = searchParams.get("expires");
    const signature = searchParams.get("signature");
    const [data, setData] = useState(null);
    const [isSuccess, setIsSuccess] = useState(false);
    const [ipAddress, setIpAddress] = useState("");

    useEffect(() => {
        const fetchIp = async () => {
            try {
                const ip = await publicIpv4();
                setIpAddress(ip);
            } catch (error) {
                console.error("Lỗi khi lấy IP:", error);
            }
        };
        fetchIp();
    }, []);

    useEffect(() => {
        if (!ipAddress) return;

        const fetchVerify = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/email/verify`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        id: id,
                        hash: hash,
                        expires: expires,
                        signature: signature,
                        ip_address: ipAddress,
                    }),
                });

                const result = await response.json();

                if (response.ok) {
                    setIsSuccess(true);
                    setData({ message: "Xác thực tài khoản thành công!" });
                } else {
                    setIsSuccess(false);
                    setData({ message: "Thông tin xác thực đã hết hạn hoặc không đúng. Vui lòng kiểm tra lại." });
                }
            } catch (error) {
                setIsSuccess(false);
                setData({ message: "Thông tin xác thực đã hết hạn hoặc không đúng. Vui lòng kiểm tra lại." });
            }
        };

        fetchVerify();
    }, [ipAddress]);

    const navi = useNavigate();

    useEffect(() => {
        document.body.style.backgroundImage = `url(${bg})`;
        document.body.style.backgroundSize = "cover";
        document.body.style.backgroundPosition = "center";
        return () => {
            document.body.style.backgroundImage = '';
        };
    }, []);

    const containerStyle = {
        display: 'flex',
        justifyContent: 'center',
        height: '100vh',
        padding: '20px',
        background: 'rgba(0, 0, 0, 0.2)',
    };

    const verifyContainerStyle = {
        width: '100%',
        maxWidth: '500px',
        background: 'rgba(255, 255, 255, 0.9)',
        borderRadius: '10px',
        boxShadow: '0 8px 15px rgba(0, 0, 0, 0.2)',
        padding: '30px',
        textAlign: 'center',
    };

    const messageTextStyle = {
        fontSize: '20px',
        fontWeight: 'bold',
        color: '#333',
        marginBottom: '20px'
    };

    const buttonStyle = {
        padding: '10px 20px',
        fontSize: '16px',
        color: '#fff',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        textDecoration: 'none'
    };

    const successMessageStyle = {
        fontSize: '15px',
        fontWeight: 'bold',
        color: 'green',
        marginBottom: '20px'
    };

    const errorMessageStyle = {
        fontSize: '15px',
        fontWeight: 'bold',
        color: 'red',
        marginBottom: '20px'
    };

    return (
        <div style={containerStyle}>
            <div style={verifyContainerStyle}>
                <h2 style={messageTextStyle}>Xác thực tài khoản</h2>
                <p style={isSuccess ? successMessageStyle : errorMessageStyle}>
                    {data ? data.message : "Đang xử lý xác thực..."}
                </p>
                <a
                    className='btn'
                    href="/"
                    style={buttonStyle}
                >Trở về trang đăng nhập</a>
            </div>
        </div>
    );
}

export default Verify;
